/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AttachmentItemResVo1
 */
export interface AttachmentItemResVo1 {
    /**
     * 上传文件真实主键。
     * @type {number}
     * @memberof AttachmentItemResVo1
     */
    uploadFileId?: number;
    /**
     * 可直接访问的文件地址。
     * @type {string}
     * @memberof AttachmentItemResVo1
     */
    fileUrl?: string;
    /**
     * 上传文件名称。
     * @type {string}
     * @memberof AttachmentItemResVo1
     */
    fileName?: string;
    /**
     * 文件扩展名，如 jpg、png。
     * @type {string}
     * @memberof AttachmentItemResVo1
     */
    fileType?: string;
    /**
     * 展示顺序。
     * @type {number}
     * @memberof AttachmentItemResVo1
     */
    sortNo?: number;
}

/**
 * Check if a given object implements the AttachmentItemResVo1 interface.
 */
export function instanceOfAttachmentItemResVo1(value: object): value is AttachmentItemResVo1 {
    return true;
}

export function AttachmentItemResVo1FromJSON(json: any): AttachmentItemResVo1 {
    return AttachmentItemResVo1FromJSONTyped(json, false);
}

export function AttachmentItemResVo1FromJSONTyped(json: any, ignoreDiscriminator: boolean): AttachmentItemResVo1 {
    if (json == null) {
        return json;
    }
    return {
        
        'uploadFileId': json['uploadFileId'] == null ? undefined : json['uploadFileId'],
        'fileUrl': json['fileUrl'] == null ? undefined : json['fileUrl'],
        'fileName': json['fileName'] == null ? undefined : json['fileName'],
        'fileType': json['fileType'] == null ? undefined : json['fileType'],
        'sortNo': json['sortNo'] == null ? undefined : json['sortNo'],
    };
}

export function AttachmentItemResVo1ToJSON(json: any): AttachmentItemResVo1 {
    return AttachmentItemResVo1ToJSONTyped(json, false);
}

export function AttachmentItemResVo1ToJSONTyped(value?: AttachmentItemResVo1 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'uploadFileId': value['uploadFileId'],
        'fileUrl': value['fileUrl'],
        'fileName': value['fileName'],
        'fileType': value['fileType'],
        'sortNo': value['sortNo'],
    };
}

